import { Camera, Store, Video, Mic, Star, TrendingUp } from 'lucide-react'
import { getTheme } from '../utils/colors'

function Collaboration({ config, isLight = false }) {
  const theme = getTheme(isLight, config.profile?.fontColor)
  const collab = config.collaboration || {}
  const types = collab.types || []

  const services = [
    {
      icon: Camera,
      title: '产品测评',
      description: '真实体验分享，从用户角度出发，详细展示产品特点和使用感受',
      features: ['真实测评', '细节展示', '使用场景']
    },
    {
      icon: Store,
      title: '探店打卡',
      description: '线下实体店探访，记录真实消费体验，为粉丝推荐优质商家',
      features: ['实地探访', '环境展示', '消费体验']
    },
    {
      icon: Video,
      title: '品牌植入',
      description: '软性品牌植入，自然融入日常内容，提升品牌曝光和好感度',
      features: ['自然植入', '场景化展示', '品牌露出']
    },
    {
      icon: Mic,
      title: '直播带货',
      description: '实时互动直播，现场演示产品，促进即时转化和销售',
      features: ['实时互动', '产品演示', '限时优惠']
    }
  ]

  return (
    <section id="collaboration" className="py-20" style={{ backgroundColor: config.profile?.sectionBackground || '#000000' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 标题 */}
        <div className="text-center mb-12">
          <h2 className={`text-3xl sm:text-4xl font-bold mb-4 ${theme.text}`}>
            合作方式
          </h2>
          <p className={`max-w-2xl mx-auto ${theme.textSecondary}`}>
            提供多样化的内容合作形式，根据品牌需求定制专属推广方案
          </p>
        </div>

        {/* 服务卡片 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {services.map((service, index) => (
            <div
              key={index}
              className={`group rounded-xl p-6 border transition-all hover:scale-[1.02] ${theme.cardBg} ${theme.cardBorder} hover:border-accent/50`}
            >
              <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-accent to-accent-light flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <service.icon className="w-6 h-6 text-white" />
              </div>
              <h3 className={`text-xl font-semibold mb-2 ${theme.text}`}>{service.title}</h3>
              <p className={`text-sm mb-4 ${theme.textSecondary}`}>{service.description}</p>
              <div className="flex flex-wrap gap-2">
                {service.features.map((feature, i) => (
                  <span
                    key={i}
                    className={`px-2 py-1 text-xs rounded ${theme.chipBg} ${theme.chipText}`}
                  >
                    {feature}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* 合作优势 */}
        <div className={`rounded-2xl p-8 border ${theme.gradientBg} ${theme.gradientBorder}`}>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 rounded-full bg-accent/20 flex items-center justify-center mx-auto mb-4">
                <TrendingUp className="w-8 h-8 text-accent" />
              </div>
              <h3 className={`text-xl font-semibold mb-2 ${theme.text}`}>高转化率</h3>
              <p className={`text-sm ${theme.textSecondary}`}>
                粉丝粘性高，互动率行业领先，助力品牌高效转化
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 rounded-full bg-purple-500/20 flex items-center justify-center mx-auto mb-4">
                <Star className="w-8 h-8 text-purple-400" />
              </div>
              <h3 className={`text-xl font-semibold mb-2 ${theme.text}`}>优质内容</h3>
              <p className={`text-sm ${theme.textSecondary}`}>
                专业内容创作团队，保证每一条作品的高质量输出
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 rounded-full bg-pink-500/20 flex items-center justify-center mx-auto mb-4">
                <Camera className="w-8 h-8 text-pink-400" />
              </div>
              <h3 className={`text-xl font-semibold mb-2 ${theme.text}`}>多平台覆盖</h3>
              <p className={`text-sm ${theme.textSecondary}`}>
                全平台矩阵运营，一次合作多平台同步推广
              </p>
            </div>
          </div>
        </div>

        {/* 合作品牌展示 */}
        {collab.brands && collab.brands.length > 0 && (
          <div className="mt-16">
            <h3 className={`text-center text-lg mb-6 ${theme.textSecondary}`}>已合作品牌</h3>
            <div className="flex flex-wrap justify-center gap-4">
              {collab.brands.map((brand, index) => (
                <div
                  key={index}
                  className={`px-6 py-3 rounded-lg font-medium ${theme.chipBg} ${theme.chipText}`}
                >
                  {brand}
                </div>
              ))}
            </div>
          </div>
        )}

      </div>
    </section>
  )
}

export default Collaboration
